import React, { useEffect, useState } from "react";

import ChevronUpIcon from "@mui/icons-material/ExpandLess";
import { PKShariaContent } from "./components/pk-sharia/pk-sharia-content";
import { useParams, useSearchParams } from "react-router-dom";
import { get, isEmpty, map } from "lodash";
import { ErrorScreen } from "../../../../components/error-screen/error-screen";
import { PKConventionalContent } from "./components/pk-conventional/pk-conventional-content";
import { PMKConventionalContent } from "./components/pmk-conventional/pmk-conventional-content";
import { PMKShariaContent } from "./components/pmk-sharia/pmk-sharia-content";
import { onboardingHttp } from "../../../onboarding/components/surveyjs/survey/http";
import { getToken } from "../../../onboarding/utils";

export const TYPE_TC = {
  PMK_CONVENTIONAL: "PMK_CONVENTIONAL",
  PMK_SHARIA: "PMK_SHARIA",
  PK_CONVENTIONAL: "PK_CONVENTIONAL",
  PK_SHARIA: "PK_SHARIA",
};

export type TAgentDetail = {
  name: string;
  address: string;
  code: string;
  phoneNumber: string | number;
};

const APIM_AGENT = get(window, "envConfig.REACT_APP_APIM_AGENT", "");
const APIM_BASE_URL = get(window, "envConfig.REACT_APP_APIM_BASE_URL", "");
const APIM_RECRUITMENT = get(window, "envConfig.REACT_APP_APIM_RECRUITMENT", "");

export const getAddressText = (agentProfile: any) => {
  const address = agentProfile?.address?.enUs || "-";
  const concatAddress = map(address, (item: any) => item);
  return concatAddress.join(" ");
};

export const getAddressTextCandidate = (dataCandidate: any) => {
  const address = dataCandidate || "";
  return (
    address?.residentialAddress +
    ", " +
    address?.city +
    ", " +
    address?.province +
    " " +
    address?.postalCode
  );
};

export const PkPmkTnc = () => {
  const params = useParams();

  const [scrollYPosition, setScrollYPosition] = useState<number>(0);
  const handleScroll = () => {
    const newScrollYPosition = window.pageYOffset;
    setScrollYPosition(newScrollYPosition);
  };
  const [searchParams, setSearchParams] = useSearchParams();
  const type: string = searchParams.get("type") as string;
  const candidateId: string = searchParams.get("candidateId") as string;

  const [agentDetail, setAgentDetail] = useState<TAgentDetail>({
    name: "-",
    code: "-",
    phoneNumber: "-",
    address: "-",
  });

  const [isError, setIsError] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const getAgentDetail = async () => {
    setIsLoading(true);

    try {
      const data = await onboardingHttp.get(
        `${APIM_BASE_URL}${APIM_AGENT}/agents/me?lang=en-US&lang=zh-HK`,
      );

      const tmp = {
        code: data?.data?.agentCode,
        name: data?.data?.displayName?.enUs || "-",
        address: getAddressText(data?.data) || "-",
        phoneNumber: data?.data?.phone?.mobile,
      };

      setAgentDetail(tmp as TAgentDetail);
      setIsLoading(false);
      setIsError(null);
    } catch (error) {
      setIsLoading(false);
      setIsError(error);
    }
  };

  const getCandidateDetail = async () => {
    setIsLoading(true);
    try {
      const data = await onboardingHttp.get(
        `${APIM_BASE_URL}${APIM_RECRUITMENT}/onboarding/forms?candidateId=${candidateId}`,
      );
      const candidateDetail = data?.data?.[0];
      const tmp = {
        code: candidateId,
        name: candidateDetail?.applicant?.local || "-",
        address:
          getAddressTextCandidate(
            candidateDetail?.modules?.personalData?.contactInformation?.questionAnswers,
          ) || "-",
        phoneNumber:
          candidateDetail?.modules?.personalData?.contactInformation?.questionAnswers
            ?.regionPhone[0]?.countryCode +
            "" +
            candidateDetail?.modules?.personalData?.contactInformation?.questionAnswers
              ?.regionPhone[0]?.mobileNumber || "-",
      };

      setAgentDetail(tmp as TAgentDetail);
      setIsLoading(false);
      setIsError(null);
    } catch (error) {
      setIsLoading(false);
      setIsError(error);
    }
  };
  const token = getToken();

  useEffect(() => {
    if (token) {
      if (!isEmpty(candidateId)) {
        getCandidateDetail();
      } else {
        getAgentDetail();
      }
    }
  }, [params?.refId, candidateId, token]);

  useEffect(() => {
    if (window.ReactNativeWebView) {
      if (isError) {
        window.ReactNativeWebView.postMessage(JSON.stringify(isError));
      } else {
        window.parent.postMessage(null);
      }
    }
  }, [isError]);

  return (
    <div className="bg-[#EEF0F8] w-full min-h-[100vh]  ">
      {isLoading ? (
        <></>
      ) : isEmpty(type) || !Object.values(TYPE_TC).includes(type) || isError ? (
        <ErrorScreen statusCode="-1" />
      ) : (
      <>
        <div className="fixed ">
          {scrollYPosition > 400 && (
            <button
              className="absolute top-[92vh] left-[50vw] bg-[#ed1b2e] w-[56px] h-[48px] rounded-full text-white    -translate-x-2/4"
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}>
              <ChevronUpIcon />
            </button>
          )}
        </div>
        <div className=" gap-2">
          <div className="bg-white ">
            {type === TYPE_TC.PK_SHARIA && <PKShariaContent agentDetail={agentDetail} />}
            {type === TYPE_TC.PMK_SHARIA && <PMKShariaContent agentDetail={agentDetail} />}
            {type === TYPE_TC.PK_CONVENTIONAL && (
              <PKConventionalContent agentDetail={agentDetail} />
            )}
            {type === TYPE_TC.PMK_CONVENTIONAL && (
              <PMKConventionalContent agentDetail={agentDetail} />
            )}
          </div>
        </div>
      </>
      )}
    </div>
  );
};
